export default __webpack_public_path__ + "static/media/affiche.9acb47fa.jpg";